<template>
    <tr v-bind:class="[rowSelectedClass]">
        <td class="small">
            <b-form-checkbox
                    v-model="selected"
                    v-on:change="toggle"
            ></b-form-checkbox>
        </td>
        <td class="text-center" v-bind:data-th="$t('tableheadings.state')">
          <a class="icon-action" v-on:click="showExtensions">
            <div v-if="data.refresh_disabled === true">
            <span
              class="badge badge-pill badge-info d-inline-flex px-2 align-items-center justify-content-center"
              v-on:click="localEnableRefresh"
            >
              <img src="/images/overview/monkey-white.svg"/>{{ $t('site.enablerefresh') }}
            </span>
            </div>
            <div v-else>
              <span v-if="updateCount == 0" class="badge badge-pill px-2 badge-success d-inline-flex align-items-center justify-content-center">
                <img src="/images/overview/monkey-white.svg"/>
              </span>
              <span v-else class="badge badge-pill badge-danger px-2 d-inline-flex align-items-center justify-content-center">
                <img src="/images/overview/monkey-white.svg"/>
                <span class="numberofupdates ml-2">
                  {{updateCount}}
                </span>
              </span>
            </div>
          </a>
        </td>
        <td class="sitename" v-bind:data-th="$t('tableheadings.name')">
            <div v-if="!editMode">
                <a class="action detail-link" v-on:click="showDetail">{{siteName}}</a>
                <a class="icon-action" v-on:click="setEditMode">
                    <font-awesome-icon :icon="['fal', 'edit']" :title="$t('icon.edit')"></font-awesome-icon>
                </a>
                <tag-list
                  :entity-id="id"
                  :entity-tags="data.tags"
                  entity-type="site"
                  @updatedTags="localSaveTags"
                />

                <div v-if="siteDescription !== ''">
                  <div class="site-description">
                    <span v-html="preparedSiteDescription"></span>
                    <span v-if="showFullDescription">
                    <a v-on:click="toggleShowFullDescription"><font-awesome-icon :icon="['fal', 'circle-minus']"></font-awesome-icon></a>
                    </span>
                    <span v-else>
                    ... <a v-on:click="toggleShowFullDescription"><font-awesome-icon :icon="['fal', 'circle-plus']"></font-awesome-icon></a>
                    </span>
                  </div>
                </div>
            </div>
            <div v-else>
              <div  class="formgrid">
                <div>
                  <label for="newNameId">
                    {{ $t("site.lablename") }}
                  </label>
                  <input
                    id="newNameId"
                    v-model="newName"
                    class="table-edit w-100"
                    v-on:blur="localSave"
                    v-on:keyup.enter="localSave"
                  />
                </div>
                <div>
                  <label for="newDescriptionId">
                    {{ $t("site.labledescription") }}
                  </label>
                  <input
                    id="newDescriptionId"
                    v-model="newDescription"
                    class="table-edit w-100"
                    v-on:blur="localSave"
                    v-on:keyup.enter="localSave"
                  />
                </div>
              </div>
              <button class="btn btn--success mt-2 float-right" v-on:click="localSave">
                {{$t('config.save')}}
              </button>
            </div>
        </td>
        <td v-if="showColumn('app_version')" class="text-center font-weight-bold" v-bind:data-th="$t('tableheadings.app_version')">
          <span v-if="coreUpdateProgress !== null && data.process_state !== 0">
              <font-awesome-icon :icon="['fal','spinner']" pulse></font-awesome-icon> {{ coreUpdateProgress }} %
          </span>
          <span v-else :class="[data.core_need_update === 0 ? 'text-success' : 'badge badge-pill badge-danger badge--small']">
              <font-awesome-icon v-if="data.app_type === 'Joomla'" :icon="['fab','joomla']" :title="$t('site.joomla')"></font-awesome-icon>
              <font-awesome-icon v-if="data.app_type === 'Wordpress'" :icon="['fab','wordpress-simple']" :title="$t('site.wordpress')"></font-awesome-icon>
              {{data.app_version}}
            </span>
        </td>
        <td v-if="showColumn('tls_expiration')" class="text-center" v-bind:data-th="$t('tableheadings.tls_expiration')">
          <font-awesome-icon v-if="!data.tls_enabled" :icon="['fal','exclamation-triangle']" :title="$t('site.notls')" class="text--danger"></font-awesome-icon>
          <span v-else>
                  <font-awesome-icon v-if="tlsDaysRemaining > 30" v-b-tooltip.top="$tc('site.daysremaning', tlsDaysRemaining, {n: tlsDaysRemaining})"  :icon="['fal','check-circle']" :title="$tc('site.daysremaning', tlsDaysRemaining, {n: tlsDaysRemaining})" class="text--success"></font-awesome-icon>
                  <font-awesome-icon v-if="tlsDaysRemaining > 0 && tlsDaysRemaining <= 30" v-b-tooltip.top="$tc('site.daysremaning', tlsDaysRemaining, {n: tlsDaysRemaining})"  :icon="['fal','exclamation-triangle']" :title="$tc('site.daysremaning', tlsDaysRemaining, {n: tlsDaysRemaining})" class="text--warning"></font-awesome-icon>
                  <font-awesome-icon v-if="tlsDaysRemaining <= 0" v-b-tooltip.top="$t('site.tlsexpired')"  :icon="['fal','exclamation-triangle']" :title="$t('site.tlsexpired')" class="text--danger"></font-awesome-icon>
              </span>
        </td>
        <td v-if="showColumn('phpversion')" class="text-center" v-bind:data-th="$t('tableheadings.phpversion')">
          {{ data.phpversion }}
        </td>
        <td v-if="showColumn('database_version')" class="text-center" v-bind:data-th="$t('tableheadings.database_version')">
          {{ data.database_version }}
        </td>
        <td v-if="showColumn('last_backup')" class="text-center" v-bind:data-th="$t('tableheadings.last_backup')">
            <span v-if="backupProgress === null" >
                <span v-b-tooltip.hover.top.html :title="lastBackupDatetime">
                  {{ lastBackupDate }}
                </span>
                <span v-if="hasPlan" v-b-tooltip.hover.top.html :title="$t('site.hasBackupSchedule')" class="text-success">
                  <font-awesome-icon :icon="['fal', 'calendar-check']" />
                </span>
                <span v-else v-b-tooltip.hover.top.html :title="$t('site.noBackupSchedule')" class="text-danger">
                  <font-awesome-icon :icon="['fal', 'calendar']" />
                </span>
            </span>
            <span v-else>
                <font-awesome-icon :icon="['fal','spinner']" pulse></font-awesome-icon> {{ backupProgress }} %
            </span>
        </td>
        <td v-if="showColumn('last_checked_backup')" class="text-center" v-bind:data-th="$t('tableheadings.last_checked_backup')">
          <div class="d-flex align-items-center">
            <span v-b-tooltip.hover.top.html :title="lastCheckedBackupDatetime">{{ lastCheckedBackupDate }}</span>
              <span v-if="hasCheckedBackup" class="ml-2">
              <font-awesome-icon v-if="data.last_checked_backup_state === 'Completed successfully'" :icon="['fal','check-circle']" :title="$t('icon.success')" class="text--success ml-1"></font-awesome-icon>
              <font-awesome-icon v-else :icon="['fal','exclamation-triangle']" :title="$t('icon.failed')" class="text--danger"></font-awesome-icon>
            </span>
          </div>
        </td>
      <td v-if="showColumn('report_setup')" class="text-center" v-bind:data-th="$t('tableheadings.report_setup')">
        <font-awesome-icon v-if="hasEmailSetup" :icon="['fal','check']" :title="$t('icon.success')" class="text--success"></font-awesome-icon>
        <font-awesome-icon v-else :icon="['fal','times']" :title="$t('icon.failed')" class="text--danger"></font-awesome-icon>
     </td>
      <td v-if="showColumn('disabled_update_sites')" class="text-center" v-bind:data-th="$t('tableheadings.disabled_update_sites')">
        {{ disabledUpdateSites }}
      </td>
      <td v-if="showColumn('update_channel')" class="text-center" v-bind:data-th="$t('tableheadings.update_channel')">
        {{ data.update_channel }}
      </td>
    </tr>

</template>

<script>

import TagList from '../Tags/TagList'

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import mixins from '../../mixins'

import moment from 'moment'

export default {

  name: 'SiteItem',

  components: {
    TagList
  },

  mixins: [mixins],

  props: [
    'id',
    'data',
    'details',
    'dirty',
    'inProgress',
    'selectedColumns'
  ],

  computed: {

    ...mapState(
      'site', [
        'siteSelected',
        'showDetailPage',
        'siteDetailId'
      ]
    ),

    ...mapState(
      'user', [
        'userTimezone'
      ]
    ),

    ...mapGetters('progress', [
      'siteCoreUpdateProgress',
      'siteBackupProgress'
    ]),

    ...mapGetters('local', ['getSitesColumns']),

    coreUpdateProgress () {
      return this.siteCoreUpdateProgress(this.id)
    },

    backupProgress () {
      return this.siteBackupProgress(this.id)
    },

    selected: {
      get () {
        return this.siteSelected.includes(this.id)
      },
      set (value) {
        // just do nothing
      }
    },

    showMessage () {
      return false
    },

    lastBackupDate () {
      const value = this.data.last_backup

      if (value === '') {
        return this.$t('site.noBackup')
      }

      return this.transformTime(value, this.userTimezone, 'DD.MM.YYYY')
    },

    lastBackupDatetime () {
      const value = this.data.last_backup

      if (value === '') {
        return this.$t('site.noBackup')
      }

      return this.transformTime(value, this.userTimezone)
    },

    hasCheckedBackup () {
      return this.data.last_checked_backup !== ''
    },

    lastCheckedBackupDate () {
      const value = this.data.last_checked_backup

      if (value === '') {
        return this.$t('site.noTestedBackup')
      }

      return this.transformTime(value, this.userTimezone, 'DD.MM.YYYY')
    },

    lastCheckedBackupDatetime () {
      const value = this.data.last_checked_backup

      if (value === '') {
        return this.$t('site.noTestedBackup')
      }

      return this.transformTime(value, this.userTimezone)
    },

    hasPlan () {
      return this.data.has_plan
    },

    rowSelectedClass () {
      return (this.siteDetailId === this.id && this.showDetailPage) ? 'selected-row' : ''
    },

    preparedSiteDescription () {
      if (this.showFullDescription) {
        return this.siteDescription.replace(/(?:\r\n|\r|\n)/g, '<br>')
      }

      return this.siteDescription.slice(0, this.descriptionLength)
    },

    siteName: {
      get () {
        return this.data.name
      },
      set (value) {
      }
    },

    siteDescription: {
      get () {
        return this.data.description
      },
      set (value) {
      }
    },

    updateCount () {
      return this.data.extensions_need_update
    },

    tlsDaysRemaining () {
      return moment(this.data.tls_expiration).diff(moment(), 'days')
    },

    disabledUpdateSites () {
      return this.data.disabled_updatesites
    },

    hasEmailSetup () {
      return this.data.has_email
    }
  },

  data () {
    return {
      siteItem: [],
      editMode: false,
      newName: '',
      newDescription: '',
      descriptionLength: 50,
      showFullDescription: false
    }
  },

  methods: {
    ...mapMutations('common', [
      'startLoading',
      'endLoading',
      'resetLoading',
      'showSidebar',
      'hideSidebar'
    ]),

    ...mapMutations('site', [
      'addSelectedSite',
      'removeSelectedSite',
      'setSiteDetailId',
      'showSiteDetailPage',
      'showSiteDetailPageExtensions',
      'closeSiteDetailPage'
    ]),

    ...mapActions('site', [
      'refreshSiteData',
      'enableRefreshSiteData',
      'setSiteDetailContent',
      'saveSiteName',
      'saveSiteDescription'
    ]),

    trash () {
      this.$router.push({ name: 'siteDestroy', params: { id: this.id } })
    },

    localEnableRefresh () {
      this.enableRefreshSiteData(this.id)
    },

    localSave () {
      this.editMode = false

      let nameSaveSuccess = true
      let descriptionSaveSuccess = true

      if (this.newName !== this.name) {
        let payload = {
          id: this.id,
          name: this.newName,
          context: {
            side_id: this.id
          }
        }

        this.saveSiteName(payload)
          .then(response => {
            this.siteName = this.newName
          })
          .catch(() => {
            nameSaveSuccess = false
          })
      }

      if (this.newDescription !== this.description) {
        let payload = {
          id: this.id,
          description: this.newDescription,
          context: {
            side_id: this.id
          }
        }

        this.saveSiteDescription(payload)
          .then(response => {
            this.siteDescription = this.newDescription
          })
          .catch(() => {
            descriptionSaveSuccess = false
          })
      }

      if (nameSaveSuccess && descriptionSaveSuccess) {
        this.$snotify.success('Saved successfully')
        return
      }

      this.$snotify.error('Error while Saving, please try again')
    },

    localSaveTags (tags) {
      this.data.tags = tags
    },

    setEditMode () {
      this.newName = this.siteName
      this.newDescription = this.siteDescription
      this.editMode = true
    },

    showExtensions () {
      this.setSiteDetailContent(this.id)
      this.showSiteDetailPageExtensions()
      this.showSiteDetailPage()
    },

    showDetail () {
      if (this.showDetailPage) {
        // Detail page visible
        if (this.id === this.siteDetailId) {
          this.showSidebar()
          this.closeSiteDetailPage()
        } else {
          this.startLoading()
          this.setSiteDetailContent(this.id).then(() => {
            this.resetLoading()
          })
        }
      } else {
        // Detail page NOT visible
        if (this.id === this.siteDetailId) {
          this.showSiteDetailPage()
          this.hideSidebar()
        } else {
          this.startLoading()
          this.setSiteDetailContent(this.id).then(() => {
            this.showSiteDetailPage()
            this.hideSidebar()
            this.resetLoading()
          })
        }
      }
    },

    toggleShowFullDescription () {
      this.showFullDescription = !this.showFullDescription
    },

    toggle (e) {
      if (e) {
        this.addSelectedSite(this.id)
      } else {
        this.removeSelectedSite(this.id)
      }
    },

    update () {
      this.refreshSiteData(this.id)
    },

    showColumn (name) {
      return this.getSitesColumns.indexOf(name) !== -1
    }
  }
}
</script>
